/** Format Firestore timestamp for chat bubbles (arena + private). */
export function formatChatTime(timestamp) {
  if (!timestamp) return '–';
  const ts = timestamp?.toMillis ? timestamp.toMillis() : (timestamp?.seconds ?? 0) * 1000;
  const d = new Date(ts);
  if (isNaN(d.getTime())) return '–';
  const now = Date.now();
  const diff = now - d.getTime();
  if (diff < 60_000) return 'Just now';
  if (diff < 3600_000) return `${Math.floor(diff / 60_000)}m ago`;
  if (diff < 86400_000) return `${Math.floor(diff / 3600_000)}h ago`;
  return d.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', hour12: true });
}
